import React from 'react';
import { Zap, Clock } from 'lucide-react';
import { Toggle } from '../ui/toggle';

const RealTimeToggle = ({ isRealTime, onToggle }) => {
  return (
    <Toggle
      pressed={isRealTime}
      onPressedChange={onToggle}
      size="sm"
      className="data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [@media(hover:hover)_and_(pointer:fine)]:hover:shadow-md"
      aria-label={isRealTime ? "Switch to Static Results" : "Switch to Real-Time Results"}
    >
      {isRealTime ? <Zap className="h-4 w-4" /> : <Clock className="h-4 w-4" />}
    </Toggle>
  );
};

export default RealTimeToggle;
